<template>
  <div>
    <div class="clearfix">
      <Form
        @submit.native.prevent
        :model="formData"
        label-position="left"
        class="mytable-titleBox"
        v-if="!isShenhe"
      >
        <div class="clearfix">
          <FormItem label="评论人昵称:" class="fl mytable-title" :label-width="86">
            <Input v-model="formData.commentator_name" placeholder="请输入评论人昵称"></Input>
          </FormItem>
          <FormItem label="评论人手机号:" class="fl mytable-title" :label-width="110">
            <Input v-model="formData.commentator_phone" placeholder="请输入评论人手机号"></Input>
          </FormItem>
          <FormItem label="评论内容:" class="fl mytable-title" :label-width="86">
            <Input v-model="formData.content" placeholder="请输入评论内容"></Input>
          </FormItem>
          <FormItem label="评论的作者:" class="fl mytable-title" :label-width="86" v-if="isAdmin">
            <Input v-model="formData.author_name" placeholder="请输入评论的作者"></Input>
          </FormItem>
          <div class="fl checkReset">
            <Button type="primary" class="fl" @click="handleQuery">查询</Button>
            <Button class="fl" @click="handleReset">重置</Button>
          </div>
          <span class="btn-del fr" @click="handleCheck" v-if="isAdmin">批量审核</span>
        </div>
        <div class="line"></div>
        <RadioGroup
          v-model.trim="formData.verify_status"
          type="button"
          class="fl mr20 mt24"
          @on-change="handleRefundchange"
          v-if="isAdmin"
        >
          <Radio :label="0">待审核</Radio>
          <Radio :label="1">已审核</Radio>
        </RadioGroup>

        <!-- 已审核状态显示 -->
        <RadioGroup
          v-model.trim="formData.is_show"
          type="button"
          class="fl mr20 mt24"
          @on-change="handleRefundchange"
          v-if="isAdmin&&formData.verify_status"
        >
          <Radio :label="empty">全部</Radio>
          <Radio :label="1">已显示</Radio>
          <Radio :label="0">已隐藏</Radio>
        </RadioGroup>
        <FormItem label="日期范围:" class="fl mytable-title ml24 mt24" :label-width="72">
          <DatePicker
            class="w240"
            v-model.trim="date"
            type="daterange"
            @on-change="handleDateChange"
            format="yyyy-MM-dd"
            placeholder="开始日期 ~ 结束日期"
          ></DatePicker>
        </FormItem>
      </Form>
    </div>
    <div class="clearfix" v-if="isShenhe">
      <span class="btn-del fr" @click="handleCheck">批量审核</span>
    </div>
    <Table
      @on-selection-change="handleTableChange"
      :loading="tableLoading"
      class="mt24"
      :columns="columns"
      :data="tableData"
    ></Table>
    <Page
      class="mt24"
      :total="total"
      :current="page_num"
      show-elevator
      show-sizer
      show-total
      @on-page-size-change="handleSizeChange"
      @on-change="handlePageChange"
    />
    <!-- 回复弹窗 -->
    <Modal
      v-model="modalVisibile"
      width="724"
      :mask-closable="false"
      title="回复评论"
      @on-cancel="handleCancel"
    >
      <Form @submit.native.prevent ref="modalForm" :model="modalForm" label-position="top">
        <div style="font-size:14px;color:#2E3133;margin-bottom:24px;word-break:break-all;word-wrap:break-word;">评论内容 : {{modalForm.content}}</div>

        <FormItem label="回复评论" style="height:84px;">
          <Input
            v-model="modalForm.reply_content"
            style="width: 650px;height:84px;"
            type="textarea"
            placeholder="请输入回复内容"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button :loading="modalLoading" type="primary" @click="handleModalSubmit">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import mixins from "@/mixins/page";
export default {
  name: "user_manage",
  mixins: [mixins],
  data() {
    return {
      //保存是否显示的数组
      isShowArr: [],
      isShenhe: Number(localStorage.getItem("isShenhe")),
      selectedVal: [],
      empty: "",
      modalLoading: false,
      modalForm: {},
      modalVisibile: false,
      isAdmin: Number(localStorage.getItem("sa")), //1 超级管理员  0作者
      // isAdmin: 0,
      vipData: [],
      date: [],
      formData: {
        verify_status: "",
        is_show: ""
      },
      formData1: {
        verify_status: "",
        is_show: ""
      },
      tableData: [],
      columns: [],
      //超级管理员  已审核
      columns1: [
        {
          type: "selection",
          align: "center"
        },
        {
          title: "评论人昵称",
          align: "center",
          key: "commentator_name"
        },
        {
          title: "手机号",
          align: "center",
          key: "commentator_phone",
          render:(h,params)=>{
            var phone =params.row.commentator_phone?params.row.commentator_phone.substr(0, 3) + "****" +params.row.commentator_phone.substr(7):'无';                  
            return h('span',phone)
          }
        },
        {
          title: "头像",
          key: "poster",
          align: "center",
          render: (h, params) => {
            return params.row.poster
              ? h("img", {
                  class: {
                    table_pic: true
                  },
                  domProps: {
                    src: params.row.poster,
                    alt: "头像"
                  },
                  on: {
                    click: () => this.$pic.init([params.row.poster])
                  }
                })
              : null;
          }
        },
        {
          title: "购买次数",
          align: "center",
          key: "buy_num"
        },
        {
          title: "会员等级",
          align: "center",
          key: "vip_name"
        },
        {
          title: "评论时间",
          align: "center",
          key: "create_time"
        },
        {
          title: "评论内容",
          key: "content",
          align: "center",
          // tooltip: true,
          render: (h, params) => {
            let content = params.row.content;
            let len = 10;
            return h(
              "div",
              {
                style: {
                  overflow: "hidden"
                },
                class: {
                  twoRow: true
                }
              },
              [
                h(
                  "Tooltip",
                  {
                    props: {
                      disabled: content && content.length < len,
                      placement: "bottom",
                      transfer: true
                    }
                  },
                  [
                    content,
                    h(
                      "span",
                      {
                        slot: "content",
                        style: {
                          whiteSpace: "normal"
                        }
                      },
                      content
                    )
                  ]
                )
              ]
            );
          }
        },
        {
          title: "评论的作者",
          align: "center",
          key: "author_name"
        },
        {
          title: "作者回复内容",
          key: "content",
          align: "center",
          // tooltip: true,
          render: (h, params) => {
            let content = params.row.reply_content;
            let len = 10;
            return h(
              "div",
              {
                style: {
                  overflow: "hidden"
                },
                class: {
                  twoRow: true
                }
              },
              [
                h(
                  "Tooltip",
                  {
                    props: {
                      disabled: content && content.length < len,
                      placement: "bottom",
                      transfer: true
                    }
                  },
                  [
                    content,
                    h(
                      "span",
                      {
                        slot: "content",
                        style: {
                          whiteSpace: "normal"
                        }
                      },
                      content
                    )
                  ]
                )
              ]
            );
          }
        },
        {
          title: "审核人",
          align: "center",
          key: "verify_name"
        },
        {
          title: "操作",
          align: "center",
          key: "age",
          render: (h, params) => {
            return params.row.is_show === 1
              ? h("span", {
                  class: {
                    btn_true: true
                  },
                  on: {
                    click: () => this.handlePostStatus(params.row)
                  }
                })
              : h("span", {
                  class: {
                    btn_false: true
                  },
                  on: {
                    click: () => this.handlePostStatus(params.row)
                  }
                });
          }
        }
      ],
      //超级管理员  未审核
      columns1_no: [
        {
          type: "selection",
          align: "center"
        },
        {
          title: "评论人昵称",
          align: "center",
          key: "commentator_name"
        },
        {
          title: "手机号",
          align: "center",
          key: "commentator_phone",
          render:(h,params)=>{
            var phone =params.row.commentator_phone?params.row.commentator_phone.substr(0, 3) + "****" +params.row.commentator_phone.substr(7):'无';                  
            return h('span',phone)
          }
        },
        {
          title: "头像",
          key: "poster",
          align: "center",
          render: (h, params) => {
            return params.row.poster
              ? h("img", {
                  class: {
                    table_pic: true
                  },
                  domProps: {
                    src: params.row.poster,
                    alt: "头像"
                  },
                  on: {
                    click: () => this.$pic.init([params.row.poster])
                  }
                })
              : null;
          }
        },
        {
          title: "购买次数",
          align: "center",
          key: "buy_num"
        },
        {
          title: "会员等级",
          align: "center",
          key: "vip_name"
        },
        {
          title: "评论时间",
          align: "center",
          key: "create_time"
        },
        {
          title: "评论内容",
          key: "content",
          align: "center",
          // tooltip: true,
          render: (h, params) => {
            let content = params.row.content;
            let len = 10;
            return h(
              "div",
              {
                style: {
                  overflow: "hidden"
                },
                class: {
                  twoRow: true
                }
              },
              [
                h(
                  "Tooltip",
                  {
                    props: {
                      disabled: content && content.length < len,
                      placement: "bottom",
                      transfer: true
                    }
                  },
                  [
                    content,
                    h(
                      "span",
                      {
                        slot: "content",
                        style: {
                          whiteSpace: "normal"
                        }
                      },
                      content
                    )
                  ]
                )
              ]
            );
          }
        },
        {
          title: "评论的作者",
          align: "center",
          key: "author_name"
        },
        {
          title: "操作",
          align: "center",
          key: "age",
          render: (h, params) => {
            return params.row.is_show === 1
              ? h("span", {
                  class: {
                    btn_true: true
                  },
                  on: {
                    click: () => this.handlePostStatus(params.row)
                  }
                })
              : h("span", {
                  class: {
                    btn_false: true
                  },
                  on: {
                    click: () => this.handlePostStatus(params.row)
                  }
                });
          }
        }
      ],
      //作者
      columns2: [
        {
          title: "评论人昵称",
          align: "center",
          key: "commentator_name"
        },
        {
          title: "手机号",
          align: "center",
          key: "commentator_phone",
          render:(h,params)=>{
            var phone =params.row.commentator_phone?params.row.commentator_phone.substr(0, 3) + "****" +params.row.commentator_phone.substr(7):'无';                  
            return h('span',phone)
          }
        },
        {
          title: "头像",
          key: "poster",
          width: 160,
          align: "center",
          render: (h, params) => {
            return params.row.poster
              ? h("img", {
                  class: {
                    table_pic: true
                  },
                  domProps: {
                    src: params.row.poster,
                    alt: "头像"
                  },
                  on: {
                    click: () => this.$pic.init([params.row.poster])
                  }
                })
              : null;
          }
        },
        {
          title: "购买次数",
          align: "center",
          key: "buy_num"
        },
        {
          title: "会员等级",
          align: "center",
          key: "vip_name"
        },
        {
          title: "评论时间",
          align: "center",
          key: "create_time"
        },
        {
          title: "评论内容",
          key: "content",
          align: "center",
          // tooltip: true,
          render: (h, params) => {
            let content = params.row.content;
            let len = 10;
            return h(
              "div",
              {
                style: {
                  overflow: "hidden"
                },
                class: {
                  twoRow: true
                }
              },
              [
                h(
                  "Tooltip",
                  {
                    props: {
                      disabled: content && content.length < len,
                      placement: "bottom",
                      transfer: true
                    }
                  },
                  [
                    content,
                    h(
                      "span",
                      {
                        slot: "content",
                        style: {
                          whiteSpace: "normal"
                        }
                      },
                      content
                    )
                  ]
                )
              ]
            );
          }
        },
        {
          title: "回复内容",
          key: "reply_content",
          align: "center",
          // tooltip: true,
          render: (h, params) => {
            let content = params.row.reply_content;
            let len = 10;
            return h(
              "div",
              {
                style: {
                  overflow: "hidden"
                },
                class: {
                  twoRow: true
                }
              },
              [
                h(
                  "Tooltip",
                  {
                    props: {
                      disabled: content && content.length < len,
                      placement: "bottom",
                      transfer: true
                    }
                  },
                  [
                    content,
                    h(
                      "span",
                      {
                        slot: "content",
                        style: {
                          whiteSpace: "normal"
                        }
                      },
                      content
                    )
                  ]
                )
              ]
            );
          }
        },
        {
          title: "操作",
          width: 130,
          align: "center",
          key: "age",
          render: (h, params) => {
            return params.row.is_reply
              ? h(
                  "span",
                  {
                    class: {
                      btn_edit: true
                    },
                    on: {
                      click: () => this.handlereply(params)
                    }
                  },
                  "删除回复"
                )
              : h(
                  "span",
                  {
                    class: {
                      btn_edit: true
                    },
                    on: {
                      click: () => this.handlereply(params)
                    }
                  },
                  "回复"
                );
          }
        }
      ]
    };
  },
  mounted() {
    //是审核员，则是超级管理员
    if (this.isShenhe) {
      this.isAdmin = 1;
      this.formData.verify_status = 0;
      this.columns = this.columns;
    }

    if (this.isAdmin) {
      //超级管理员
      this.columns = this.columns1_no;
      this.formData.verify_status = 0;
    } else {
      //作者
      this.columns = this.columns2;
      //审核过得
      this.formData.verify_status = 1;
    }
    this.handleQuery();
  },
  methods: {
    handleTableChange(val) {
      this.selectedVal = val;
    },
    //回复提交
    handleModalSubmit() {
      this.modalLoading = true;
      this.$api
        .commentReply({
          ...this.modalForm
        })
        .then(res => {
          if (res.code === 0) {
            this.$Message.success(res.msg);
            this.modalVisibile = false;
            this.getTableData();
            this.handleCancel();
          } else {
            this.$Message.error(res.msg);
            this.modalForm.sort = this.modalForm.sort + "";
          }
          this.modalLoading = false;
        });
    },
    //批量审核
    handleCheck() {
      if (this.selectedVal.length === 0) {
        this.$Message.warning("请勾选要审核的列表");
        return;
      }
      this.$Modal.confirm({
        render: h => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true
                }
              },
              "审核评论"
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true
                }
              },
              "确定要审核当前所选评论吗?"
            )
          ]);
        },
        onOk: () => {
          let checkParams = this.selectedVal.map(item => {
            var json = {
              id: item.id,
              is_show: ""
            };
            this.tableData.map(item1 => {
              if (item.id === item1.id) {
                json.is_show = item1.is_show;
              }
            });
            return json;
          });

          //对应审核和隐藏显示状态is_show，组合数据
          checkParams.map((item, index) => {
            this.isShowArr.map((item1, index1) => {
              if (item.id === item1.id) {
                checkParams[index].is_show = item1.is_show;
              }
            });
          });
          // .join(",");
          this.$api
            .commentCheck({
              jsonParam: checkParams
            })
            .then(res => {
              if (res.code === 0) {
                this.$Message.success(res.msg);
                //已审核
                if (this.formData.verify_status) {
                  this.getTableData();
                } else {
                  //待审核
                  this.handleQuery();
                }
                this.isShowArr = [];
                this.selectedVal = [];
              } else {
                this.$Message.error(res.msg);
              }
            });
        }
      });
    },
    //回复
    handlereply(params) {
      this.modalForm.id = params.row.id;
      this.modalForm.content = params.row.content;

      if (!params.row.is_reply) {
        // 回复
        this.modalVisibile = true;
      } else {
        // 删除
        this.$Modal.confirm({
          render: h => {
            return h("div", [
              h(
                "div",
                {
                  class: {
                    modal_icon_del: true
                  }
                },
                "删除回复"
              ),
              h(
                "div",
                {
                  class: {
                    modal_text: true
                  }
                },
                "确定要删除该回复吗？删除后可重新回复该评论"
              )
            ]);
          },
          onOk: () => {
            this.$api
              .commentReplyDel({
                id: this.modalForm.id
              })
              .then(res => {
                if (res.code === 0) {
                  this.$Message.success(res.msg);
                  this.getTableData();
                } else {
                  this.$Message.error(res.msg);
                }
              });
          }
        });
      }
    },
    handlePostStatus(param) {
      //样式
      this.tableData.map(item => {
        //操作状态
        if (item.id === param.id) {
          item.is_show = param.is_show ? 0 : 1;
        }
        //选中状态保持不变
        if (this.selectedVal.length) {
          this.selectedVal.map(item1 => {
            if (item1.id === item.id) {
              item._checked = true;
            }
          });
        } else {
          item._checked = false;
        }
        return item;
      });

      let flag = true;
      let paramData = {
        id: param.id,
        is_show: param.is_show === 0 ? 1 : 0
      };

      if (this.isShowArr.length === 0) {
        this.isShowArr.push(paramData);
      } else {
        this.isShowArr.map((item, index) => {
          //已经选择过，组数中有
          if (item.id === param.id) {
            // console.log("重复");
            if (this.isShowArr[index].is_show) {
              this.isShowArr[index].is_show = 0;
            } else {
              this.isShowArr[index].is_show = 1;
            }
            flag = false;
          }
        });
        if (flag) {
          this.isShowArr.push(paramData);
        }
      }

      // this.$api.commentIsShow(paramData).then(res => {
      //   // this.$Message.success('操作成功')
      //   this.tableData.map(item => {
      //     //操作状态
      //     if (item.id === param.id) {
      //       item.is_show = paramData.is_show;
      //     }
      //     //选中状态保持不变
      //     if (this.selectedVal.length) {
      //       this.selectedVal.map(item1 => {
      //         if (item1.id === item.id) {
      //           item._checked = true;
      //         }
      //       });
      //     }

      //     return item;
      //   });

      //   // this.getTableData()
      // });
    },
    handleCancel() {
      this.modalVisibile = false;
      this.modalForm = Object.assign({}, this.modalForm1);
    },
    //日期范围
    handleDateChange(val) {
      if (val[0]) {
        this.formData.start_time = val[0] + " 00:00:00";
        this.formData.end_time = val[1] + " 23:59:59";
      } else {
        this.formData.start_time = "";
        this.formData.end_time = "";
      }
      this.handleQuery();
    },
    handleRefundchange() {
      //已审核
      if (this.formData.verify_status) {
        this.columns = this.columns1;
      } else {
        //待审核
        this.columns = this.columns1_no;
        this.formData.is_show = "";
      }
      this.handleQuery();
    },
    handleReset() {
      this.formData = Object.assign({}, this.formData1);
      this.date = [];
      //是审核员，则是超级管理员
      if (this.isShenhe) {
        this.isAdmin = 1;
        this.formData.verify_status = 0;
        this.columns = this.columns;
      }
      if (this.isAdmin) {
        //超级管理员
        this.columns = this.columns1_no;
        this.formData.verify_status = 0;
      } else {
        //作者
        this.columns = this.columns2;
        //审核过得
        this.formData.verify_status = 1;
      }
      this.handleQuery();
    },
    handleQuery() {
      this.page_num = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      this.$api
        .commentList({
          ...this.formData,
          page_num: this.page_num,
          page_size: this.page_size
        })
        .then(res => {
          if (res.code === 0) {
            this.tableData = res.data.list;
            this.total = res.data.total_row;
          } else {
            this.$Message.error(res.msg);
          }
          this.tableLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .table_pic {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: block;
  margin: 0 auto;
}
/deep/ .btn_true {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url("../../assets/images/true.png") no-repeat;
  -webkit-background-size: 16px 16px;
  background-size: 16px 16px;
  cursor: pointer;
}
/deep/ .btn_false {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url("../../assets/images/false.png") no-repeat;
  -webkit-background-size: 16px 16px;
  background-size: 16px 16px;
  cursor: pointer;
}
/deep/.cursor {
  cursor: pointer;
}
/deep/textarea.ivu-input {
  height: 84px;
}
</style>
